import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { 
  FaReact, FaAngular, FaMobile, FaNodeJs, 
  FaAws, FaGitAlt, FaMicrosoft, FaCode, FaDatabase, FaDocker
} from 'react-icons/fa';
import { SiDotnet, SiMysql, SiMongodb, SiPython, SiGooglecloud, SiNextdotjs, SiPostgresql, SiTekton, SiSpringboot, SiPostman, SiGraphql, SiTerraform, SiGithubactions, SiNginx } from 'react-icons/si';
import './Skills.css';

const Skills = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const skillCategories = [
    {
      title: t('skills.frontend', 'Frontend'),
      skills: [
        { name: 'Angular', icon: <FaAngular />, color: '#DD0031' },
        { name: 'React', icon: <FaReact />, color: '#61DAFB' },
        { name: 'Next.js', icon: <SiNextdotjs />, color: '#000000' },
        { name: 'React Native', icon: <FaMobile />, color: '#61DAFB' }
      ]
    },
    {
      title: t('skills.backend', 'Backend'),
      skills: [
        { name: '.NET', icon: <SiDotnet />, color: '#512BD4' },
        { name: 'Spring Boot', icon: <SiSpringboot />, color: '#6DB33F' },
        { name: 'FastAPI', icon: <SiPython />, color: '#3776AB' },
        { name: 'Node.js', icon: <FaNodeJs />, color: '#339933' },
        { name: 'Entity Framework', icon: <SiDotnet />, color: '#512BD4' },
        { name: 'GraphQL', icon: <SiGraphql />, color: '#E10098' }
      ]
    },
    {
      title: t('skills.database', 'Base de Datos'),
      skills: [
        { name: 'MongoDB', icon: <SiMongodb />, color: '#47A248' },
        { name: 'MySQL', icon: <SiMysql />, color: '#4479A1' },
        { name: 'SQL Server', icon: <FaDatabase />, color: '#CC2927' },
        { name: 'PostgreSQL', icon: <SiPostgresql />, color: '#4169E1' },
        { name: 'Supabase', icon: <SiPostgresql />, color: '#3ECF8E' }
      ]
    },
    {
      title: t('skills.cloud', 'Cloud Platforms'),
      skills: [
        { name: 'AWS', icon: <FaAws />, color: '#FF9900' },
        { name: 'GCP', icon: <SiGooglecloud />, color: '#4285F4' }
      ]
    },
    {
      title: t('skills.devops', 'DevOps & CI/CD'),
      skills: [
        { name: 'Tekton', icon: <SiTekton />, color: '#FF5722' },
        { name: 'Docker', icon: <FaDocker />, color: '#2496ED' },
        { name: 'GitHub Actions', icon: <SiGithubactions />, color: '#2088FF' },
        { name: 'Terraform', icon: <SiTerraform />, color: '#844FBA' },
        { name: 'Nginx', icon: <SiNginx />, color: '#009639' }
      ]
    },
    {
      title: t('skills.devtools', 'Tools'),
      skills: [
        { name: 'Git', icon: <FaGitAlt />, color: '#F05032' },
        { name: 'Postman', icon: <SiPostman />, color: '#FF6C37' },
        { name: 'TFS', icon: <FaMicrosoft />, color: '#0078D7' }
      ]
    }
  ];

  return (
    <section id="skills" className="section skills">
      <div className="container">
        <h2 className="section-title">{t('skills.title')}</h2>
        
        <div ref={ref} className="skills-categories">
          {skillCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className={`skill-category ${inView ? 'fade-in' : ''}`} style={{ animationDelay: `${categoryIndex * 0.1}s` }}>
              <h3 className="category-title">
                <FaCode className="category-icon" aria-hidden="true" />
                {category.title}
              </h3>
              <div className="skills-grid">
                {category.skills.map((skill, index) => (
                  <div key={index} className="skill-item" style={{ '--skill-color': skill.color }}>
                    <div className="skill-icon" style={{ color: skill.color }} aria-hidden="true">
                      {skill.icon}
                    </div>
                    <div className="skill-name">{skill.name}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;